/**
 * @author yuanzeyu
 * @date 2020/10/16
 * @desc
 */
import { message } from 'antd';
import DApp from './index';
import { LocaleNames } from '../../enum';

class Onto extends DApp {
  constructor(ontId: string) {
    super(ontId);
    localStorage.setItem(LocaleNames.LOGIN_TYPE, 'Onto');
  }

  static tryGetLocaleDApp(): Onto | null {
    const ont = localStorage.getItem(LocaleNames.ONT);
    const jwt = localStorage.getItem(LocaleNames.JWT_CACHE_NAME);
    const scoreId = localStorage.getItem(LocaleNames.SCORE_ID_CACHE);
    const score = localStorage.getItem(LocaleNames.SCORE_CACHE); // may be empty
    if (ont && jwt && scoreId) {
      const onto = new Onto(ont);
      onto.setJwtStr(jwt).setScoreResultId(scoreId).setAddressListWithJwt();
      if (score) {
        onto.setScore(score);
      }
      return onto;
    }
    return null;
  }

  public async fetchScore() {
    try {
      const result = await this.fetchScorePms();
      this.setScore(result);
    } catch (e) {
      message.error(e.message);
    }
  }
}

export default Onto;
